<template>
  <div>
    <b-input-group class="mb-3">
      <b-form-input
        type="text"
        class="form-control"
        placeholder="Company Full Name"
        autocomplete="customer_full_name"
        v-model="form.full_name"
        @change="preFillShortName"
      />
    </b-input-group>

    <b-input-group class="mb-3">
      <b-form-input
        type="text"
        class="form-control"
        placeholder="Company Short Name"
        autocomplete="customer_full_name"
        v-model="form.short_name"
      />
    </b-input-group>
  </div>
</template>

<script>
export default {
  name: "CustomerFormGroup",
  props: ["customer"],
  data() {
    return {
      form: {
        full_name: null,
        short_name: null
      },
      available_roles: ["Grower", "Agronomist"]
    };
  },
  methods: {
    preFillShortName: function() {
      if (this.form.short_name === null) {
        this.form.short_name = this.form.full_name;
      }
    },
    fillForm() {
      if (this.customer) {
        for (let i in this.form) {
          if (this.customer[i]) {
            this.form[i] = this.customer[i];
          }
        }
      }
    }
  },
  watch: {
    form: {
      handler: function() {
        this.$emit("onCustomerChange", this.form);
      },
      deep: true
    },
    customer: {
      handler: function() {
        this.fillForm();
      },
      deep: true
    }
  },
  created() {
    this.fillForm();
  }
};
</script>
